import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream-100 font-sans antialiased" data-id="element-0" data-mp="2wjqgz5t882m4">
      <noscript data-id="element-1" data-mp="28u5x8kp911bs">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2290894421720846&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="28tmfb3zlmcxr" />
      </noscript>
      <UrgencyBar data-id="element-3" data-mp="3ij66mgga9xb1" />
      <Hero data-id="element-4" data-mp="3ijpcuzwkmx98" />
      <main data-id="element-5" data-mp="3ii4t85bsoyq5">
        <HookSection data-id="element-6" data-mp="3mlj82snzz920" />
        <PainSection data-id="element-7" data-mp="3ml17jjuay8oa" />
        <RevelationSection data-id="element-8" data-mp="3mk868ye44bdj" />
        <OfferSection data-id="element-9" data-mp="3mjga9mglsbmq" />
        <PricingSection data-id="element-10" data-mp="3rc9hqi3ghy2i" />
        <FaqSection data-id="element-11" data-mp="3rbzo8kj7d8s2" />
        <GuaranteeSection data-id="element-12" data-mp="3rdkl4gszp3t3" />
      </main>
      <Footer data-id="element-13" data-mp="3relwkmdx3sbc" />
    </div>;
}